module.exports = __webpack_public_path__ + "static/media/Group 7-A2.3202ba77.svg";